import { render, staticRenderFns } from "./ArchievedInQualityRequests.vue?vue&type=template&id=11b5c122&scoped=true&"
import script from "./ArchievedInQualityRequests.vue?vue&type=script&lang=js&"
export * from "./ArchievedInQualityRequests.vue?vue&type=script&lang=js&"
import style0 from "./ArchievedInQualityRequests.vue?vue&type=style&index=0&id=11b5c122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b5c122",
  null
  
)

export default component.exports